"use strict";
/**
 * @module Services.SessionFetchQuery
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
var error_report_list_serialiser_1 = require("./../../services/error-report-list-serialiser");
var session_fetch_query_result_1 = require("./../../services/session-fetch-query/session-fetch-query-result");
/**
 * Read a session property map from the stream
 *
 * @param bis  the input stream
 * @return     the property map that was read
 */
function readSession(bis) {
    var startTime = null;
    if (Codec.readByte(bis) === 1) {
        startTime = Codec.readInt64(bis);
    }
    var properties = Codec.readDictionary(bis, Codec.readString);
    if (startTime) {
        properties.$StartTime = startTime.toString();
    }
    return properties;
}
/**
 * Serialiser for {@link SessionFetchQueryResult}
 */
var SessionFetchQueryResultSerialiserClass = /** @class */ (function (_super) {
    __extends(SessionFetchQueryResultSerialiserClass, _super);
    function SessionFetchQueryResultSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link SessionFetchQueryResult} from the stream
     *
     * @param bis  the input stream
     * @return     the {@link SessionFetchQueryResult} that was read
     */
    SessionFetchQueryResultSerialiserClass.prototype.read = function (bis) {
        if (Codec.readByte(bis) === 0) {
            var sessions = Codec.readCollection(bis, readSession);
            var totalSelected = Codec.readInt32(bis);
            return new session_fetch_query_result_1.SessionFetchQueryResult(sessions, totalSelected);
        }
        else {
            var errors = error_report_list_serialiser_1.ErrorReportListSerialiser.read(bis);
            return new session_fetch_query_result_1.SessionFetchQueryResult(undefined, undefined, errors);
        }
    };
    return SessionFetchQueryResultSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.SessionFetchQueryResultSerialiserClass = SessionFetchQueryResultSerialiserClass;
/**
 * The {@link SessionFetchQueryResultSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.SessionFetchQueryResultSerialiser = new SessionFetchQueryResultSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/session-fetch-query/session-fetch-query-result-serialiser.js
// module id = 1375
// module chunks = 1